import { arenaBoundsFor } from './balance'

export const KNIGHT_CHARGE_SPEED = 850
export const KNIGHT_CHARGE_ACCEL_MS = 150
export const KNIGHT_CHARGE_BRAKE = 2600
export const KNIGHT_CHARGE_STRIDE = 120

export function knightChargeStopX(dir: 1 | -1): number {
  const walls = arenaBoundsFor('vigil-knight')
  return dir < 0 ? walls.leftWall + 55 : walls.rightWall - 55
}

export const KNIGHT_CHARGE_BRAKE_DISTANCE = KNIGHT_CHARGE_SPEED ** 2 / (2 * KNIGHT_CHARGE_BRAKE)
export const KNIGHT_CHARGE_SCRAPE_MS = 2 * KNIGHT_CHARGE_BRAKE_DISTANCE / KNIGHT_CHARGE_SPEED * 1000

export function knightChargeRunDistance(ms: number): number {
  const t = Math.max(0, ms)
  if (t < KNIGHT_CHARGE_ACCEL_MS) return KNIGHT_CHARGE_SPEED * t * t / (2 * KNIGHT_CHARGE_ACCEL_MS * 1000)
  return KNIGHT_CHARGE_SPEED * (t - KNIGHT_CHARGE_ACCEL_MS / 2) / 1000
}

export function knightChargeRunMs(startX: number, dir: 1 | -1): number {
  const distance = Math.max(0, (knightChargeStopX(dir) - startX) * dir - KNIGHT_CHARGE_BRAKE_DISTANCE)
  const rampDistance = knightChargeRunDistance(KNIGHT_CHARGE_ACCEL_MS)
  return distance <= rampDistance
    ? Math.sqrt(2 * distance * KNIGHT_CHARGE_ACCEL_MS * 1000 / KNIGHT_CHARGE_SPEED)
    : KNIGHT_CHARGE_ACCEL_MS + (distance - rampDistance) * 1000 / KNIGHT_CHARGE_SPEED
}

export function knightChargeScrapeDistance(ms: number): number {
  const u = Math.min(1, Math.max(0, ms / KNIGHT_CHARGE_SCRAPE_MS))
  return KNIGHT_CHARGE_BRAKE_DISTANCE * (1 - (1 - u) ** 2)
}
